import { Outlet } from 'react-router-dom';
import { AppHeader } from '@/components/AppHeader';
import { Sidebar } from '@/components/shell/Sidebar';
import { BottomNav } from '@/components/BottomNav';
import { useEagerPrefetch } from '@/api/hooks';
import { NotificationProvider } from '@/contexts/NotificationContext';
import { ClientScopeProvider } from '@/contexts/ClientScopeContext';
import { PreferenceEffects } from '@/components/shell/PreferenceEffects';
import { DocumentTitle } from '@/components/shell/DocumentTitle';
import { NavHistoryTracker } from '@/components/shell/NavHistoryTracker';
import { LazyPage } from '@/components/LazyPage';
import { RouteGuard } from '@/components/shell/RouteGuard';
import { ViewAsBanner } from '@/components/shell/ViewAsBanner';
import { PhoneSwitch } from '@/components/shell/PhoneSwitch';

export default function App() {
  useEagerPrefetch();

  return (
    <NotificationProvider>
      <ClientScopeProvider>
        <PreferenceEffects/>
        <NavHistoryTracker/>
        <DocumentTitle/>
        <div className="flex h-full flex-col bg-background-muted">
          <AppHeader/>
          <ViewAsBanner/>
          {/* Header (3.5rem) on top; sidebar + page below. Pages that size to the viewport allow for the header only. */}
          <div className="flex min-h-0 flex-1">
            <Sidebar/>
            <main className="min-w-0 flex-1 overflow-auto pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0">
              {/* Pages are code-split (main.tsx): one shared Suspense boundary for all of them. */}
              <PhoneSwitch/>
              <LazyPage><RouteGuard><Outlet/></RouteGuard></LazyPage>
            </main>
          </div>
          <BottomNav/>
        </div>
      </ClientScopeProvider>
    </NotificationProvider>
  );
}
